export default "__VITE_ASSET__CZE2h9C9__"